import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { success } from 'plugins/toastr';
import { fetchFunnelIfNeeded, saveFunnel } from 'funnel/actions/funnel';
import PageLoader from 'common/components/PageLoader';
import ResourceCard from 'common/components/ResourceCard';
import FunnelHeader from 'funnel/components/FunnelHeader';
import FunnelForm from 'funnel/components/FunnelForm';
import FunnelMenu from 'funnel/components/FunnelMenu';

const ReceiveError = () => (
  <div className="ui negative message">
    <div className="header">Erreur de chargement</div>
    <p>Une erreur est survenue pendant le chargement.</p>
  </div>
);

const SaveError = () => (
  <div className="ui negative message">
    <div className="header">Erreur de sauvegarde</div>
    <p>Une erreur est survenue pendant la sauvegarde.</p>
  </div>
);

const mapStateToProps = state => {
  const { funnel } = state.funnels;
  const { funnel: current, ...rest } = funnel;

  return {
    current,
    ...rest,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchFunnel: () => dispatch(fetchFunnelIfNeeded(ownProps.route.funnel)),
  saveFunnel: fields => dispatch(saveFunnel(ownProps.route.funnel, fields)),
});
class CoreLayout extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    location: PropTypes.object.isRequired,
    isFetching: PropTypes.bool,
    receiveError: PropTypes.object,
    saveError: PropTypes.object,
    current: PropTypes.object,
    fetchFunnel: PropTypes.func.isRequired,
    saveFunnel: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.onSubmitFunnel = this.onSubmitFunnel.bind(this);
    this.onSaveFunnel = this.onSaveFunnel.bind(this);
  }

  onSubmitFunnel(fields) {
    const { image } = this.refs;

    this.props
      .saveFunnel({
        image: image.getResource(),
        image_id: image.getValue(),
        ...fields,
      })
      .then(() => success('Mise à jour effectuée avec succès'));
  }

  onSaveFunnel() {
    // Submitting manually
    this.refs.form.submit();
  }

  componentWillMount() {
    this.props.fetchFunnel();
  }

  render() {
    const {
      current,
      isFetching,
      receiveError,
      saveError,
      children,
      location,
    } = this.props;

    if (receiveError) {
      return <ReceiveError />;
    }

    if (saveError) {
      return <SaveError />;
    }

    if (isFetching || !current) {
      return <PageLoader title={'Chargement'} />;
    }

    const resource = current ? current.image : null;

    return (
      <div>
        <FunnelHeader
          name={current.name}
          location={location}
          onSave={this.onSaveFunnel}
        />
        <div className="ui bottom attached segment">
          <div className="ui grid">
            <div className="two wide column">
              <ResourceCard
                ref="image"
                name="image"
                title="Image"
                resource={resource}
              />
            </div>
            <div className="fourteen wide column">
              <FunnelForm ref="form" onSubmit={this.onSubmitFunnel} />
            </div>
          </div>
        </div>
        <FunnelMenu />
        {children}
      </div>
    );
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), pure)(
  CoreLayout
);



// WEBPACK FOOTER //
// ./src/modules/funnel/layouts/CoreLayout.js